<!--  -->
<template>
  <div class="agreement_c">
    <div class="main_title">神州邦邦用户账号使用规范</div>
    <div class="main_item">
      <p>
        • 第一条
        为了维护神州邦邦平台和谐的商业氛围，推动服务交易的繁荣，保障用户账号相关的合法权益，维护神州邦邦平台正常运营秩序，根据《神州邦邦平台服务规则》及《神州邦邦平台服务协议》，制定本规定。
      </p>
    </div>
    <div class="main_item">
      <p>
        • 第二条
        用户为神州邦邦平台账号的权利所有人，应在严格遵循本规定的前提下，进行账号注册，并使用和管理。神州邦邦平台用户在适用本规定上一律平等。
      </p>
    </div>
    <div class="main_item">
      <p>• 第三条 账号注册</p>
      <ul class="content_wrap1">
        <li><p>用户应当严格遵循神州邦邦平台的注册流程完成账号注册。</p></li>
        <li>
          <p>
            用户不得以虚假信息进行账号注册，账号名称、简介等注册信息不得存在平台禁止发布的信息或违法不良信息。
          </p>
        </li>
        <li><p>用户不得冒用社会机构、名人及其他第三方注册账号。</p></li>
      </ul>
    </div>
    <div class="main_item">
      <p>• 第四条 账号安全</p>
      <ul class="content_wrap1">
        <li>
          <p>
            用户须自行负责账号和密码的安全，且须对在该账号下的所有行为（包括但不限于发布需求信息、网上点击同意各类协议、规则、参与需求投标等）承担责任。
          </p>
        </li>
        <li>
          <p>用户有权根据需要更改账号密码。</p>
        </li>
        <li>
          <p>
            因用户的过错或其他非归于神州邦邦平台的原因所进行的行为导致的任何损失由用户自行承担，该行为包括但不限于：
          </p>
          <p>1、不按照交易提示操作；</p>
          <p>2、未及时进行交易操作；</p>
          <p>3、遗忘或泄漏密码；</p>
          <p>4、密码被他人破解；</p>
          <p>5、用户使用的计算机被他人侵入。</p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <p>• 第五条 账号归属</p>
      <ul class="content_wrap1">
        <li>
          <p>神州邦邦平台有权未经通知回收符合以下条件的不活跃账户：</p>
          <p>1、连续180天未登录神州邦邦APP的账号；</p>
          <p>2、不存在未到期的有效业务。</p>
        </li>
        <li>
          <p>
            用户不得以任何形式擅自转让或授权他人使用自己在本网站的用户帐号（实名认证通过后，不能进行变更）。
          </p>
        </li>
        <li>
          <p>
            账号因所属人不明的情况产生纠纷或其他因司法行政等国家公职部门工作要求的情况下，神州邦邦平台有权对账号进行锁定处理。因纠纷情况锁定导致的任何损失及责任由发生纠纷的双方共同承担，锁定账号中尚有余额的
            ，将退至账号绑定的银行卡。
          </p>
        </li>
        <li>
          <p>
            作为神州邦邦平台经营者，为使您更好地使用神州邦邦平台的各项服务，保障您的账户安全，神州邦邦平台可要求您按神州邦邦平台规则要求及我国法律规定完成实名认证。神州邦邦平台用户账号归属以该账号实名认证信息为准，如您未进行实名认证的，将影响到您正常使用神州邦邦平台的各项服务和权益保障。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <p>• 第六条 账号注销</p>
      <ul class="content_wrap1">
        <li>
          <p>
            您可以注销账号。可通过神州邦邦平台官方客服热线400-676-3988要求神州邦邦平台客服提供账号注销服务。
          </p>
        </li>
        <li>
          <p>
            如您注销账号，请按照神州邦邦平台相关规定妥善处理资金、发票及在途交易等事宜。
          </p>
        </li>
      </ul>
    </div>
    <div class="main_item">
      <p>• 第七条 本规定自发布之日起生效并执行。</p>
    </div>
    <div class="main_item">
      <p>• 第八条 本规定修订权及最终解释权归神州邦邦平台所有。</p>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
</style>